import Choices from 'choices.js';
class Fieldset {
    constructor ($fieldset) {
        this.$fieldset = $fieldset;
        // in case we don't init fieldset with data-fieldset, we can pass data-fieldset-type for input or select type
        this.inputType = this.$fieldset.getAttribute('data-fieldset') ? this.$fieldset.getAttribute('data-fieldset') : this.$fieldset.getAttribute('data-fieldset-type');
        this.choice = undefined;
    }

    initialize () {
        if (this.inputType === 'text-input') {
            const $input = this.$fieldset.querySelector('input, textarea');

            if ($input) {
                this.bindTextInputEvents($input);
                this.handleInputFillState($input);
            }
        } else if (this.inputType === 'select') {
            const $select = this.$fieldset.querySelector('select');

            if ($select) {
                if (window.browser.csshover) {
                    this.initChoices($select);
                } else {
                    this.bindNativeSelectEvents($select);
                }
                this.handleSelectFillState($select);
            }
        } else if (this.inputType === 'search-select') {
            const $select = this.$fieldset.querySelector('select');

            if ($select) {
                if (window.browser.csshover) {
                    this.initSearchSelectChoices($select);
                }
                this.handleSelectFillState($select);
            }
        } else {
            console.warn('no valid fieldset attribute found');
        }
    }

    bindTextInputEvents ($input) {
        $input.addEventListener('focus', () => {
            this.onFieldsetFocus();
        });

        $input.addEventListener('blur', () => {
            this.onFieldsetBlur();
        });

        $input.addEventListener('input', () => {
            this.handleInputFillState($input);
        });
    }

    handleInputFillState ($input) {
        const valueLength = $input.value.length;
        if (valueLength > 0) {
            this.$fieldset.classList.add('fieldset--filled');
        } else {
            this.$fieldset.classList.remove('fieldset--filled');
        }
    }

    initChoices ($select) {
        this.choice = new Choices($select, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            value: 'aland', label: 'tst'
        });

        this.choice.passedElement.element.addEventListener('showDropdown', () => {
            this.onFieldsetFocus();
        }, false);

        this.choice.passedElement.element.addEventListener('hideDropdown', () => {
            this.onFieldsetBlur();
        }, false);

        this.choice.passedElement.element.addEventListener('change', (e) => {
            const $select = e.srcElement;
            this.handleSelectFillState($select);
        }, false);
    }

    // only used for mobile devices
    bindNativeSelectEvents ($select) {
        $select.addEventListener('change', () => {
            this.handleSelectFillState($select);
        }, false);
    }

    onFieldsetFocus () {
        this.$fieldset.classList.add('fieldset--focused');
    }

    onFieldsetBlur () {
        this.$fieldset.classList.remove('fieldset--focused');
    }

    handleSelectFillState ($select) {
        let optionValue = '';

        if (this.choice !== undefined) {
            optionValue = this.choice.getValue(true);
        } else {
            const $selectedOption = $select.options[$select.selectedIndex];
            optionValue = $selectedOption.value;
        }

        if (optionValue !== '') {
            this.$fieldset.classList.add('fieldset--filled');
        } else {
            this.$fieldset.classList.remove('fieldset--filled');
        }
    }

    initSearchSelectChoices ($select) {
        this.choice = new Choices($select, {
            itemSelectText: '',
            shouldSort: false
        });

        this.choice.passedElement.element.addEventListener('showDropdown', () => {
            this.onFieldsetFocus();
        }, false);

        this.choice.passedElement.element.addEventListener('hideDropdown', () => {
            this.onFieldsetBlur();
        }, false);

        this.choice.passedElement.element.addEventListener('change', (e) => {
            const $select = e.srcElement;
            this.handleSelectFillState($select);
        }, false);
    }
}

export { Fieldset };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-fieldset]');
        $$roots.forEach($root => {
            const $rootAPI = new Fieldset($root);
            $rootAPI.initialize();
        });
    }
});
